import { render, staticRenderFns } from "./StagingAuthorFormStepTwo.vue?vue&type=template&id=3eca1ca1"
import script from "./StagingAuthorFormStepTwo.vue?vue&type=script&lang=ts"
export * from "./StagingAuthorFormStepTwo.vue?vue&type=script&lang=ts"
import style0 from "./StagingAuthorFormStepTwo.vue?vue&type=style&index=0&id=3eca1ca1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports